<template>
  <div id="app" class="admin">
    <Menu/>
    <div class="admin-router">
      <router-view/>
    </div>
  </div>
</template>

<script>
import Menu from './Menu.vue'

export default {
  components: {
    Menu
  }
}
</script>
